import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { CHECKBOX_DEFAULT_SIZE, SelectionEnum } from "@ryde/shared";

import { CheckboxControlledContainerStyled } from "./checkboxes.styled";

interface ICheckboxControlledTstateProps {
  checked: SelectionEnum;
  width?: number;
  height?: number;
  setChecked: (checked: SelectionEnum) => void;
}

export const CheckboxControlledTstate: FC<ICheckboxControlledTstateProps> = ({
  checked,
  setChecked,
  width = CHECKBOX_DEFAULT_SIZE,
  height = CHECKBOX_DEFAULT_SIZE,
}) => {
  return (
    <CheckboxControlledContainerStyled data-e2e-value={checked}>
      {checked === SelectionEnum.None && (
        <SVG_MUI.CheckboxUncheckedSVG
          onClick={() => setChecked(SelectionEnum.All)}
          width={width}
          height={height}
        />
      )}
      {checked === SelectionEnum.All && (
        <SVG_MUI.CheckboxCheckedBlueSVG
          onClick={() => setChecked(SelectionEnum.None)}
          width={width}
          height={height}
        />
      )}
      {checked === SelectionEnum.Some && (
        <SVG_MUI.CheckboxGrayedSVG
          onClick={() => setChecked(SelectionEnum.All)}
          width={width}
          height={height}
        />
      )}
    </CheckboxControlledContainerStyled>
  );
};
